import styled from 'styled-components';
import { renderStyledElementStyles } from '../../../../helpers';

export const StyledTableLayout = styled.div`
  overflow-x: auto;

  ${({ theme }) =>
    renderStyledElementStyles(
      theme,
      theme.module.dStyles.elements.tableWrapper,
    )}
  ${({ theme }) =>
    renderStyledElementStyles(
      theme,
      theme.module.vStyles.elements.tableWrapper,
    )}
  
  table {
    border-spacing: 0;
    border-collapse: collapse;
    border-style: hidden;

    width: 100%;
    max-width: 100%;

    ${({ theme }) =>
      renderStyledElementStyles(theme, theme.module.dStyles.elements.table)}
    ${({ theme }) =>
      renderStyledElementStyles(theme, theme.module.vStyles.elements.table)}
  }

  thead {
    ${({ theme }) =>
      renderStyledElementStyles(
        theme,
        theme.module.dStyles.elements?.table?.elements?.thead,
      )}
    ${({ theme }) =>
      renderStyledElementStyles(
        theme,
        theme.module.vStyles.elements?.table?.elements?.thead,
      )}
    
    tr {
      ${({ theme }) =>
        renderStyledElementStyles(
          theme,
          theme.module.dStyles.elements.table?.elements?.thead?.elements?.tr,
        )}
      ${({ theme }) =>
        renderStyledElementStyles(
          theme,
          theme.module.vStyles.elements.table?.elements?.thead?.elements?.tr,
        )}
    }
  }

  th {
    vertical-align: top;

    ${({ theme }) =>
      renderStyledElementStyles(
        theme,
        theme.module.dStyles.elements.table?.elements?.thead?.elements?.th,
      )}
    ${({ theme }) =>
      renderStyledElementStyles(
        theme,
        theme.module.vStyles.elements.table?.elements?.thead?.elements?.th,
      )}

    &:first-child {
      ${({ theme }) =>
        renderStyledElementStyles(
          theme,
          theme.module.dStyles.elements.table?.elements?.thead?.elements?.th
            ?.firstChild,
        )}
      ${({ theme }) =>
        renderStyledElementStyles(
          theme,
          theme.module.vStyles.elements.table?.elements?.thead?.elements?.th
            ?.firstChild,
        )}
    }

    &:last-child {
      ${({ theme }) =>
        renderStyledElementStyles(
          theme,
          theme.module.dStyles.elements.table?.elements?.thead?.elements?.th
            ?.lastChild,
        )}
      ${({ theme }) =>
        renderStyledElementStyles(
          theme,
          theme.module.vStyles.elements.table?.elements?.thead?.elements?.th
            ?.lastChild,
        )}
    }

    p {
      margin: 0;
      padding: 0;

      ${({ theme }) =>
        renderStyledElementStyles(
          theme,
          theme.module.dStyles.elements.table?.elements?.thead?.elements?.text,
        )}
      ${({ theme }) =>
        renderStyledElementStyles(
          theme,
          theme.module.vStyles.elements.table?.elements?.thead?.elements?.text,
        )}
    }
  }

  tbody {
    ${({ theme }) =>
      renderStyledElementStyles(
        theme,
        theme.module.dStyles.elements.table?.elements?.tbody,
      )}
    ${({ theme }) =>
      renderStyledElementStyles(
        theme,
        theme.module.vStyles.elements.table?.elements?.tbody,
      )}

    tr {
      ${({ theme }) =>
        renderStyledElementStyles(
          theme,
          theme.module.dStyles.elements.table?.elements?.tr,
        )}
      ${({ theme }) =>
        renderStyledElementStyles(
          theme,
          theme.module.vStyles.elements.table?.elements?.tr,
        )}
    }

    td {
      vertical-align: top;

      ${({ theme }) =>
        renderStyledElementStyles(
          theme,
          theme.module.dStyles.elements.table?.elements?.td,
        )}
      ${({ theme }) =>
        renderStyledElementStyles(
          theme,
          theme.module.vStyles.elements.table?.elements?.td,
        )}
  
      &:first-child {
        ${({ theme }) =>
          renderStyledElementStyles(
            theme,
            theme.module.dStyles.elements.table?.elements?.td?.firstChild,
          )}
        ${({ theme }) =>
          renderStyledElementStyles(
            theme,
            theme.module.vStyles.elements.table?.elements?.td?.firstChild,
          )}
      }

      &:last-child {
        ${({ theme }) =>
          renderStyledElementStyles(
            theme,
            theme.module.dStyles.elements.table?.elements?.td?.lastChild,
          )}
        ${({ theme }) =>
          renderStyledElementStyles(
            theme,
            theme.module.vStyles.elements.table?.elements?.td?.lastChild,
          )}
      }
    }
  }
`;

export const StyledTableHeader = styled.div`
  display: flex;
  align-items: center;
  white-space: nowrap;
  gap: 4px;
`;

export const StyledTableInteractiveHeader = styled(StyledTableHeader)`
  user-select: none;
  cursor: pointer;
`;

export const StyledTableMenuPosition = styled.div`
  top: 46px;
  position: absolute;
  z-index: 99999;
`;
